<template>
<div class="container main">
  <div class="row">
    <div class="col-md-12 title-block">
      <div class="title">
        МОИ ГРУППЫ
      </div>
    </div>
    <div class="col-12 group_table">
      <group-list-component v-for="(group, index) in groups" :group="group" :key="group.id_group" v-on:deleteRow="deleteRow(index)" />
    </div>
    <div class="col-12 empty-group-list-block" v-if="empty_group_list">
        <p>У вас нет ни одной группы кранов, добавьте группу и тогда сможете продолжить работу</p>
    </div>
    <div class="loader" v-if="load_group_list || add_group_process">
      <loader-component />
    </div>
    <div class="col-md-12 group_add">
      <a class="aquazor-btn" @click="createGroup">Добавить группу</a>
    </div>
    <div class="col-12 group-list-text-after-add-button">
      <h3>
        Группы позволяют объединить множество кранов и датчиков в единую систему. Датчики являются общими для всех кранов группы. Тревога хотя бы одного датчика заставит среагировать все краны группы.
      </h3>
    </div>
  </div>
</div>
</template>

<script>
import config from '@/config.js'
import auth from '@/auth.js'
import axios from 'axios'
import {
  store
} from '@/store'
import groupRow from './elements/group_row.vue'
import loader from './elements/loader.vue'

//   $store.getters.layout = 'app-layout'

export default {
  name: 'Groups',
  created() {
    group_list_start(this)
  },
  data() {
    return {
      groups: [],
      load_group_list: false,
      group_list_status: true,
      add_group_process: false,
      empty_group_list: false
    }
  },
  methods: {
    deleteRow: function (index_row) {
      this.groups.splice(index_row, 1)
    },
    createGroup: function () {
      create_group(this)
    }

  },
  components: {
    'group-list-component': groupRow,
    'loader-component': loader
  },
  beforeDestroy() {
    this.group_list_status = false
  },
}

function group_list_start(vue_obj) {
  if (vue_obj.group_list_status) {
    get_group_list(vue_obj)
    setTimeout(function () {
      group_list_start(vue_obj)
    }, config.UPDATE_PERIOD)
  }
}

function get_group_list(vue_obj) {
  if (!!localStorage.token && vue_obj.group_list_status) {
    if (vue_obj.groups.length == 0 && !vue_obj.add_group_process && !vue_obj.empty_group_list) vue_obj.load_group_list = true
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    axios({
        method: 'POST',
        url: config.API_HOST + '/groups/list_groups',
        data: post_data
      })
      .then(function (response) {
        vue_obj.load_group_list = false
        vue_obj.add_group_process = false
        if (vue_obj.groups.length == 0) {
          vue_obj.groups = response.data.groups
        } else {
          response.data.groups.forEach(element => {
            let group_index = vue_obj.groups.map(item => item.id_group).indexOf(element.id_group)
            if (group_index >= 0) {
              vue_obj.groups[group_index].name = element.name
              vue_obj.groups[group_index].status = element.status
              vue_obj.groups[group_index].status_text = element.status_text
            } else {
              vue_obj.groups.push(element)
            }
          })
        }
        if (vue_obj.groups.length == 0 && !vue_obj.add_group_process) {
            vue_obj.empty_group_list = true
        }
        else {
            vue_obj.empty_group_list = false
        }
        vue_obj.groups.forEach((view_element, index_element) => {
          let group_index = response.data.groups.map(item => item.id_group).indexOf(view_element.id_group)
          if (group_index < 0) {
            vue_obj.deleteRow(index_element)
          }
        })
      })
      .catch(function (error) {

      })
  }
}

function create_group(vue_obj) {
  if (!!localStorage.token) {
    vue_obj.add_group_process = true
    vue_obj.empty_group_list = false
    var post_data = new FormData()
    post_data.set('token', localStorage.token)
    axios({
        method: 'POST',
        url: config.API_HOST + '/groups/create_group',
        data: post_data
      })
      .then(function (response) {
        get_group_list(vue_obj)
      })
      .catch(function (error) {

      })
  }
}
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/groups-list.vue